import type { ResponsiveAction } from "./types";
import { isIconOnlySize } from "./utils";

import { Button } from "@/components/ui/button";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { cn } from "@/lib/utils";

const ActionButton = ({ action }: { action: ResponsiveAction }) => {
  const iconOnly = isIconOnlySize(action);

  const shouldShowTooltip = Boolean(action.tooltip) && (action.showTooltip || action.disabled);

  if (!shouldShowTooltip) {
    return (
      <Button
        onClick={action.onClick}
        variant={action.variant ?? "outline"}
        size={action.size ?? "sm"}
        disabled={action.disabled}
        aria-label={action["aria-label"] ?? action.label}
        className={cn(!iconOnly && action.icon && "gap-1.5", action.className)}
      >
        {action.icon ? (
          <span className="inline-flex h-4 w-4 shrink-0 items-center [&>svg]:h-4 [&>svg]:w-4">
            {action.icon}
          </span>
        ) : null}
        {iconOnly ? null : action.label}
      </Button>
    );
  }

  return (
    <BasicTooltip content={action.tooltip} shouldShow>
      <span className="inline-flex">
        <Button
          onClick={action.onClick}
          variant={action.variant ?? "outline"}
          size={action.size ?? "sm"}
          disabled={action.disabled}
          aria-label={action["aria-label"] ?? action.label}
          className={cn(!iconOnly && action.icon && "gap-1.5", action.className)}
        >
          {action.icon ? (
            <span className="inline-flex h-4 w-4 shrink-0 items-center [&>svg]:h-4 [&>svg]:w-4">
              {action.icon}
            </span>
          ) : null}
          {iconOnly ? null : action.label}
        </Button>
      </span>
    </BasicTooltip>
  );
};

export default ActionButton;
